module.exports = __webpack_public_path__ + "./static/img/profile-icon.896488b75b42a12926c9f6f1d4dbb4a9.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/img/employee/profile-icon.png
// module id = ./client/src/assets/img/employee/profile-icon.png
// module chunks = 0